const StockerCapacityBar = new URL('../../icons/stocker-capacity-bar.png', import.meta.url).href

export default {
  type: 'StockerCapacityBar',
  description: 'StockerCapacityBar',
  icon: StockerCapacityBar,
  group: 'SCS',
  model: {
    type: 'StockerCapacityBar',
    left: 100,
    top: 100,
    width: 200,
    height: 60,
    maxCapacity: 100,
    highWatermark: 100,
    currentUsage: 0
  }
}
